import type { FC } from 'react';
import { memo } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  List,
  ListItem,
  Typography,
} from '@mui/material';
import type { SavedCreativeFilterSummaryRow } from '../../utils/savedCreativeFilters';

interface DeleteSavedFilterDialogProps {
  open: boolean;
  savedSummaryLines: SavedCreativeFilterSummaryRow[];
  onCancel: () => void;
  onConfirm: () => void;
}

const DeleteSavedFilterDialog: FC<DeleteSavedFilterDialogProps> = ({
  open,
  savedSummaryLines,
  onCancel,
  onConfirm,
}) => (
  <Dialog
    open={open}
    onClose={onCancel}
    PaperProps={{
      sx: { maxWidth: 460, width: '90%' },
    }}
  >
    <DialogTitle>Delete saved filter?</DialogTitle>
    <DialogContent>
      <Typography variant="body1" sx={{ mb: 1.5 }}>
        The following saved filter values will be deleted. This cannot be undone.
      </Typography>
      <List dense disablePadding>
        {savedSummaryLines.map((row) => (
          <ListItem
            key={row.name}
            disableGutters
            sx={{
              py: 2,
              px: 1,
              bgcolor: '#f8f9ff',
              mb: 0.25,
              display: 'flex',
              alignItems: 'flex-start',
              gap: 2,
            }}
          >
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ flex: '0 0 110px', fontWeight: 500 }}
            >
              {row.name}
            </Typography>
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Typography variant="body2" sx={{ wordBreak: 'break-word' }}>
                {row.value}
              </Typography>
            </Box>
          </ListItem>
        ))}
      </List>
    </DialogContent>
    <DialogActions sx={{ px: 3, pb: 2 }}>
      <Button size="small" variant="text" color="inherit" onClick={onCancel}>
        Cancel
      </Button>
      <Button size="small" variant="contained" color="error" onClick={onConfirm}>
        Delete
      </Button>
    </DialogActions>
  </Dialog>
);

export default memo(DeleteSavedFilterDialog);
